import { InspectionCase } from './inspection-case.dto';

export class InspectionValueCaseDto extends InspectionCase {
  value?: string;
}
export class InspectionValueCase extends InspectionValueCaseDto {
  constructor(data: InspectionValueCaseDto = {}) {
    super(data);
    this.value = data.value;
  }
}
